import { useEffect, useState } from 'react';
import { useQuery } from 'react-query';
import { maskCep } from '../../Auxiliar/Masks';
import { findAddressByCep } from './addressService';

const digits = (value) =>
  String(value || '')
    .replace(/\D/g, '')
    .slice(0, 8);

export default function useOrganizationAddress(initialAddress = {}) {
  const [address, setAddress] = useState(() => ({
    ...initialAddress,
    cep: maskCep(digits(initialAddress?.cep)),
  }));
  const [requestedCep, setRequestedCep] = useState('');
  const currentCep = digits(address.cep);
  const query = useQuery(
    ['address', 'viaCep', requestedCep],
    () => findAddressByCep(requestedCep),
    {
      enabled: requestedCep.length === 8 && requestedCep === currentCep,
      staleTime: 10 * 60 * 1000,
      retry: false,
      refetchOnWindowFocus: false,
      refetchOnReconnect: false,
    }
  );

  useEffect(() => {
    if (!query.data || requestedCep !== currentCep) return;
    setAddress((previous) => {
      const next = { ...previous };
      Object.entries(query.data).forEach(([name, value]) => {
        if (value && (name !== 'complemento' || !previous.complemento)) next[name] = value;
      });
      return next;
    });
  }, [query.data, requestedCep, currentCep]);

  function changeField(name, value) {
    if (name === 'cep') {
      if (digits(value) !== currentCep) setRequestedCep('');
      value = maskCep(digits(value));
    }
    setAddress((previous) => ({ ...previous, [name]: value }));
  }

  function lookupCep() {
    if (currentCep.length !== 8) return;
    if (requestedCep === currentCep && query.isError) {
      query.refetch();
    } else {
      setRequestedCep(currentCep);
    }
  }

  return {
    address,
    changeField,
    lookupCep,
    isFetching: query.isFetching,
    error: query.isError
      ? query.error?.message || 'Não foi possível consultar o CEP. Preencha o endereço manualmente.'
      : '',
  };
}
